import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function LabourDashboard() {
  const navigate = useNavigate();
  const [labour, setLabour]   = useState(null);
  const [stats, setStats]     = useState(null);
  const [recent, setRecent]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navItems = [
    { label:"Dashboard",     emoji:"🏠", path:"/labour/dashboard",    active:true },
    { label:"My Attendance", emoji:"📅", path:"/labour/attendance" },
    { label:"My Salary",     emoji:"💰", path:"/labour/salary" },
    { label:"My Payments",   emoji:"💳", path:"/labour/payments" },
    { label:"Profile",       emoji:"👤", path:"/labour/profile" },
  ];

  const ST = {
    full:    { label:"Full Day",  bg:"#D1FAE5", tc:"#059669" },
    half:    { label:"Half Day",  bg:"#FEF3C7", tc:"#D97706" },
    overtime:{ label:"Overtime",  bg:"#DBEAFE", tc:"#0369A1" },
    absent:  { label:"Absent",    bg:"#FEF2F2", tc:"#DC2626" },
    holiday: { label:"Holiday",   bg:"#FEF3C7", tc:"#B45309" },
    leave:   { label:"On Leave",  bg:"#EDE9FE", tc:"#7C3AED" },
  };

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [profileRes, attendRes] = await Promise.all([
          api.get("/labour/me"),
          api.get("/attendance/my"),
        ]);
        const profile = profileRes.data.labour;
        setLabour(profile);

        const now   = new Date();
        const month = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}`;
        // Backend returns { success, data: [...] }
        const all   = attendRes.data?.data || attendRes.data || [];
        const monthly = all.filter(r => r.date?.startsWith(month));

        const WORKED = ["full","half","overtime"];
        const fullD  = monthly.filter(r=>r.status==="full").length;
        const halfD  = monthly.filter(r=>r.status==="half").length;
        const otD    = monthly.filter(r=>r.status==="overtime").length;
        const absD   = monthly.filter(r=>r.status==="absent").length;
        const wrkD   = monthly.filter(r=>WORKED.includes(r.status)).length;
        const totalOTHrs = monthly.filter(r=>r.status==="overtime").reduce((s,r)=>s+(r.overtimeHours||0),0);
        const pct    = monthly.length ? Math.round((wrkD/monthly.length)*100) : 0;

        setStats({ fullD, halfD, otD, absD, wrkD, totalOTHrs, pct, total: monthly.length });
        setRecent([...all].sort((a,b)=>new Date(b.date)-new Date(a.date)).slice(0,5));
      } catch(e){ console.error(e); }
      finally { setLoading(false); }
    };
    fetchAll();
  }, []);

  const ini = labour?.name?.split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase() || "?";
  const month = new Date().toLocaleDateString("en-IN",{month:"long",year:"numeric"});

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        @keyframes fadeUp { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }
        @keyframes spin   { to{transform:rotate(360deg)} }
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
        body{font-family:'Plus Jakarta Sans',sans-serif;background:#FAF7F4;}
        .sidebar{width:220px;flex-shrink:0;background:#fff;border-right:1.5px solid #E7E5E4;padding:24px 14px;display:flex;flex-direction:column;gap:6px;position:sticky;top:0;height:100vh;overflow-y:auto;}
        .topbar{display:none;}
        .hamburger{display:none;align-items:center;justify-content:center;width:40px;height:40px;border-radius:10px;border:1.5px solid #E7E5E4;background:#fff;cursor:pointer;flex-shrink:0;}
        .sidebar-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:40;}
        .nav-btn{display:flex;align-items:center;gap:9px;width:100%;padding:10px 12px;border-radius:10px;border:none;background:none;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;font-weight:600;color:#78716C;cursor:pointer;transition:background .15s,color .15s;text-align:left;}
        .nav-btn:hover,.nav-btn.active{background:#FEF3C7;color:#D97706;}
        .nav-btn.danger:hover{background:#FEF2F2;color:#DC2626;}
        .stat-card{background:#fff;border:1.5px solid #E7E5E4;border-radius:16px;padding:18px;animation:fadeUp .4s ease both;transition:transform .2s,box-shadow .2s;}
        .stat-card:hover{transform:translateY(-3px);box-shadow:0 10px 28px rgba(0,0,0,.07);}
        @media(max-width:768px){
          .sidebar{position:fixed;left:0;top:0;z-index:50;transform:translateX(-100%);transition:transform .28s ease;height:100%;}
          .sidebar.open{transform:translateX(0);}
          .sidebar-overlay.open{display:block;}
          .topbar{display:flex;align-items:center;gap:12px;padding:14px 16px;background:#fff;border-bottom:1.5px solid #E7E5E4;position:sticky;top:0;z-index:30;}
          .hamburger{display:flex;}
          .main-wrap{flex-direction:column!important;}
          .main-content{padding:16px!important;}
          .stats-grid{grid-template-columns:1fr 1fr!important;}
        }
        @media(max-width:420px){.stats-grid{grid-template-columns:1fr!important;}}
        @media(min-width:769px) and (max-width:1100px){.sidebar{width:190px;}}
      `}</style>

      <div className="main-wrap" style={{display:"flex",minHeight:"100vh",fontFamily:"'Plus Jakarta Sans',sans-serif",background:"#FAF7F4"}}>
        <div className={`sidebar-overlay ${sidebarOpen?"open":""}`} onClick={()=>setSidebarOpen(false)}/>

        {/* SIDEBAR */}
        <aside className={`sidebar ${sidebarOpen?"open":""}`}>
          <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"28px",padding:"0 4px"}}>
            <div style={{width:"36px",height:"36px",background:"linear-gradient(135deg,#92400E,#D97706)",borderRadius:"10px",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <span style={{fontSize:"18px"}}>🪚</span>
            </div>
            <div>
              <p style={{fontWeight:"800",fontSize:"15px",color:"#1C1917"}}>Craftigo</p>
              <p style={{fontSize:"11px",color:"#A8A29E",fontWeight:"500"}}>Labour Panel</p>
            </div>
          </div>
          <p style={{fontSize:"11px",fontWeight:"700",color:"#C4B5A4",letterSpacing:"0.7px",textTransform:"uppercase",padding:"0 6px",marginBottom:"6px"}}>Menu</p>
          {navItems.map(n=>(
            <button key={n.label} className={`nav-btn ${n.active?"active":""}`} onClick={()=>{navigate(n.path);setSidebarOpen(false);}}>
              {n.emoji} {n.label}
            </button>
          ))}
          <div style={{flex:1}}/>
          <div style={{padding:"12px",background:"#E0F2FE",borderRadius:"12px",border:"1px solid #BAE6FD",marginBottom:"10px"}}>
            <p style={{fontSize:"12px",fontWeight:"700",color:"#0369A1"}}>🔨 Labour</p>
            <p style={{fontSize:"11px",color:"#0369A1",marginTop:"2px",opacity:.8}}>{labour?.name||"..."}</p>
          </div>
          <button className="nav-btn danger" onClick={()=>{localStorage.clear();navigate("/login");}}>🚪 Logout</button>
        </aside>

        <div style={{flex:1,display:"flex",flexDirection:"column",minWidth:0}}>
          {/* TOPBAR */}
          <div className="topbar">
            <button className="hamburger" onClick={()=>setSidebarOpen(true)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6" x2="21" y2="6" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="18" x2="21" y2="18" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <span style={{fontWeight:"800",fontSize:"16px",color:"#1C1917"}}>🏠 Dashboard</span>
          </div>

          <main className="main-content" style={{padding:"28px 28px",flex:1,overflowY:"auto"}}>

            {/* Welcome */}
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"20px",flexWrap:"wrap",gap:"12px"}}>
              <div style={{display:"flex",alignItems:"center",gap:"14px"}}>
                <div style={{width:"52px",height:"52px",borderRadius:"50%",background:"linear-gradient(135deg,#DBEAFE,#BAE6FD)",border:"2px solid #BAE6FD",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"18px",fontWeight:"800",color:"#0369A1",flexShrink:0}}>
                  {ini}
                </div>
                <div>
                  <p style={{fontSize:"13px",color:"#A8A29E",fontWeight:"500"}}>Good day 👋</p>
                  <h1 style={{fontSize:"22px",fontWeight:"800",color:"#1C1917",letterSpacing:"-0.5px"}}>{labour?.name||"Loading..."}</h1>
                </div>
              </div>
              <div style={{padding:"7px 14px",background:"#E0F2FE",border:"1px solid #BAE6FD",borderRadius:"20px"}}>
                <span style={{fontSize:"11px",fontWeight:"700",color:"#0369A1"}}>🔨 {month}</span>
              </div>
            </div>

            <div style={{height:"1px",background:"#E7E5E4",marginBottom:"20px"}}/>
            <p style={{fontSize:"11px",fontWeight:"700",color:"#A8A29E",letterSpacing:"0.8px",textTransform:"uppercase",marginBottom:"14px"}}>This Month Overview</p>

            {loading ? (
              <div style={{padding:"60px",textAlign:"center"}}>
                <div style={{width:"32px",height:"32px",border:"3px solid #FDE68A",borderTop:"3px solid #D97706",borderRadius:"50%",animation:"spin .7s linear infinite",margin:"0 auto"}}/>
              </div>
            ) : (
              <>
                {/* Stat cards */}
                <div className="stats-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:"12px",marginBottom:"24px"}}>
                  {[
                    {label:"Days Worked",    val:stats?.wrkD||0,         emoji:"✅", color:"#059669", bg:"#D1FAE5", border:"#A7F3D0"},
                    {label:"Full Days",      val:stats?.fullD||0,        emoji:"🟢", color:"#059669", bg:"#D1FAE5", border:"#A7F3D0"},
                    {label:"Half Days",      val:stats?.halfD||0,        emoji:"🟡", color:"#D97706", bg:"#FEF3C7", border:"#FDE68A"},
                    {label:"Absent",         val:stats?.absD||0,         emoji:"❌", color:"#DC2626", bg:"#FEF2F2", border:"#FECACA"},
                    {label:"Overtime Days",  val:stats?.otD||0,          emoji:"⏱️", color:"#0369A1", bg:"#DBEAFE", border:"#BAE6FD"},
                    {label:"OT Hours",       val:`${stats?.totalOTHrs||0}h`, emoji:"⚡", color:"#0369A1", bg:"#DBEAFE", border:"#BAE6FD"},
                  ].map((c,i)=>(
                    <div key={c.label} className="stat-card" style={{animationDelay:`${i*.06}s`,position:"relative",overflow:"hidden"}}>
                      <div style={{position:"absolute",top:0,left:0,right:0,height:"3px",background:c.color,borderRadius:"16px 16px 0 0"}}/>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"10px"}}>
                        <div style={{width:"38px",height:"38px",borderRadius:"10px",background:c.bg,border:`1.5px solid ${c.border}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"18px"}}>
                          {c.emoji}
                        </div>
                        <span style={{fontSize:"22px",fontWeight:"800",color:c.color}}>{c.val}</span>
                      </div>
                      <p style={{fontSize:"13px",fontWeight:"700",color:"#1C1917"}}>{c.label}</p>
                    </div>
                  ))}
                </div>

                {/* Attendance rate */}
                <div style={{background:"#fff",border:"1.5px solid #E7E5E4",borderRadius:"16px",padding:"18px",marginBottom:"20px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"10px"}}>
                    <p style={{fontSize:"14px",fontWeight:"700",color:"#1C1917"}}>Attendance Rate</p>
                    <span style={{fontSize:"16px",fontWeight:"800",color:stats?.pct>=75?"#059669":stats?.pct>=50?"#D97706":"#DC2626"}}>{stats?.pct||0}%</span>
                  </div>
                  <div style={{height:"8px",background:"#F5F5F4",borderRadius:"99px",overflow:"hidden"}}>
                    <div style={{height:"100%",width:`${stats?.pct||0}%`,background:stats?.pct>=75?"#059669":stats?.pct>=50?"#D97706":"#DC2626",borderRadius:"99px",transition:"width .6s ease"}}/>
                  </div>
                  <p style={{fontSize:"12px",color:"#A8A29E",marginTop:"6px"}}>{stats?.wrkD||0} worked days out of {stats?.total||0} total</p>
                </div>

                {/* Recent attendance */}
                <div style={{background:"#fff",border:"1.5px solid #E7E5E4",borderRadius:"16px",padding:"18px",marginBottom:"20px"}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"14px"}}>
                    <p style={{fontSize:"14px",fontWeight:"700",color:"#1C1917"}}>Recent Attendance</p>
                    <button onClick={()=>navigate("/labour/attendance")} style={{fontSize:"12px",fontWeight:"700",color:"#D97706",background:"#FEF3C7",border:"1px solid #FDE68A",borderRadius:"8px",padding:"5px 10px",cursor:"pointer"}}>View All →</button>
                  </div>
                  {recent.length===0 ? (
                    <p style={{fontSize:"13px",color:"#A8A29E",textAlign:"center",padding:"20px 0"}}>No attendance records yet</p>
                  ) : recent.map((r,i)=>{
                    const d  = new Date(r.date);
                    const st = ST[r.status]||{label:r.status,bg:"#F5F5F4",tc:"#78716C"};
                    return (
                      <div key={r._id||i} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 0",borderBottom:i<recent.length-1?"1px solid #F5F5F4":"none"}}>
                        <div>
                          <p style={{fontSize:"14px",fontWeight:"600",color:"#1C1917"}}>{d.toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"})}</p>
                          <p style={{fontSize:"12px",color:"#A8A29E"}}>{d.toLocaleDateString("en-IN",{weekday:"long"})}</p>
                        </div>
                        <span style={{padding:"4px 12px",borderRadius:"20px",fontSize:"12px",fontWeight:"700",background:st.bg,color:st.tc}}>
                          {st.label}{r.overtimeHours?` ${r.overtimeHours}h`:""}
                        </span>
                      </div>
                    );
                  })}
                </div>

                {/* Quick links */}
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))",gap:"10px"}}>
                  {[
                    {label:"My Attendance", emoji:"📅", path:"/labour/attendance", bg:"#D1FAE5", bc:"#A7F3D0", tc:"#059669"},
                    {label:"My Salary",     emoji:"💰", path:"/labour/salary",     bg:"#FEF3C7", bc:"#FDE68A", tc:"#D97706"},
                    {label:"My Payments",   emoji:"💳", path:"/labour/payments",   bg:"#EDE9FE", bc:"#DDD6FE", tc:"#7C3AED"},
                    {label:"Profile",       emoji:"👤", path:"/labour/profile",    bg:"#DBEAFE", bc:"#BAE6FD", tc:"#0369A1"},
                  ].map(q=>(
                    <button key={q.label} onClick={()=>navigate(q.path)}
                      style={{padding:"14px",borderRadius:"14px",border:`1.5px solid ${q.bc}`,background:q.bg,fontFamily:"'Plus Jakarta Sans',sans-serif",fontSize:"13px",fontWeight:"700",color:q.tc,cursor:"pointer",textAlign:"center",transition:"all .15s"}}
                      onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 6px 16px rgba(0,0,0,.08)";}}
                      onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}>
                      <div style={{fontSize:"22px",marginBottom:"6px"}}>{q.emoji}</div>
                      {q.label}
                    </button>
                  ))}
                </div>
              </>
            )}
          </main>
        </div>
      </div>
    </>
  );
}